import React from 'react'
import CircleLoader from '../../icons/animated/CircleLoader'
import './Loading.scss'

const LoadingPanel = ({ text }) => {
  return (
    <div className='loading-panel'>
      <div className='-content'>
        <CircleLoader />
        {text && 
          <div className="-text">{text}</div>
        }
      </div>
    </div>
  )
}

export default LoadingPanel